import { render } from "./App.vue?vue&type=template&id=34eb277e"
const script = {}
script.render = render

export default script